/* HHL: "Compare" in Verified compatible parts (snippets/hhl-pairs.liquid, assets/hhl-compare.css; owner 2026-10-14).
   A card whose group has comparison features (set in the HHL app: Compatibility › a group › Comparison) shows a
   Compare button. It opens a larger view of the card's parts side by side: photo, name, price, Add, and one row per
   feature, read from each product's specs metafields (sections/hhl-pair-specs.liquid). The parts are already
   checked to fit, so this is only about choosing. Opening and closing ease; nothing pops.
   Badges sit on the photo's corner in the theme's own label style (.label, colors from Theme settings), like the
   product cards: each product's own badges, plus "Popular" on the most reviewed part (at least POPULAR_MIN reviews,
   and more than any other part compared). */
(function () {
  'use strict';
  if (window.HHLCompare) return;
  var root = HHL.root();
  var specs = {};
  var dialog = null;
  var POPULAR_MIN = 10;

  // A part's data: from the page (written with its tile), else kept from earlier this visit, else asked for once.
  var STORE = 'hhl-compare-specs';
  var kept = {};
  try { kept = JSON.parse(sessionStorage.getItem(STORE) || '{}') || {}; } catch (e) { kept = {}; }
  var keep = function (handle, data) {
    kept[handle] = data;
    try { sessionStorage.setItem(STORE, JSON.stringify(kept)); } catch (e) { /* full or blocked: page memory only */ }
  };
  var inPage = function (handle) {
    var node = document.querySelector('script[data-hhl-spec="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  };

  var getSpec = function (handle) {
    if (!specs[handle]) {
      var ready = inPage(handle) || kept[handle];
      specs[handle] = ready ? Promise.resolve(ready) : fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=hhl-pair-specs')
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var json = doc.querySelector('[data-hhl-spec]');
          var data = json ? JSON.parse(json.textContent) : null;
          if (data) keep(handle, data);
          return data;
        })
        .catch(function (e) { delete specs[handle]; throw e; });
    }
    return specs[handle];
  };

  var handlesOf = function (card) {
    return Array.prototype.map.call(card.querySelectorAll('[data-hhl-pairs-slide][data-handle]'), function (s) { return s.getAttribute('data-handle'); });
  };

  // Before Compare is opened: once a card that can compare comes near the screen (or the Compare button is
  // pointed at), the parts the page doesn't have yet are fetched in the background, a few at a time.
  var prefetch = function (card) {
    if (card.hhlPrefetched) return;
    card.hhlPrefetched = true;
    var todo = handlesOf(card).filter(function (h) { return !specs[h] && !inPage(h) && !kept[h]; });
    var next = function () {
      var h = todo.shift();
      if (!h) return;
      getSpec(h).then(next, next);
    };
    for (var n = 0; n < 4; n++) next();
  };

  var watch = function () {
    var cards = document.querySelectorAll('[data-hhl-pairs-card][data-hhl-pairs-features]');
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) { cards.forEach(prefetch); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { io.unobserve(entry.target); prefetch(entry.target); }
      });
    }, { rootMargin: '600px 0px' });
    cards.forEach(function (card) { io.observe(card); });
  };
  watch();

  ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var button = e.target.closest && e.target.closest('[data-hhl-pairs-compare]');
      var card = button && button.closest('[data-hhl-pairs-card]');
      if (card) prefetch(card);
    }, { capture: true, passive: true });
  });

  var el = function (tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  };

  /** A value as customers read it: Yes / No, lists joined, numbers with their unit, "—" when unknown. */
  var show = function (feature, value) {
    if (value == null || value === '' || (Array.isArray(value) && !value.length)) return '—';
    if (feature.t === 'yesno') return value === true || value === 'true' ? 'Yes' : 'No';
    if (Array.isArray(value)) return value.join(', ');
    if (feature.t === 'number' && feature.u) return value + ' ' + feature.u;
    return String(value);
  };

  var build = function () {
    dialog = el('dialog', 'hhl-compare');
    dialog.setAttribute('aria-labelledby', 'hhl-compare-title');
    dialog.innerHTML =
      '<div class="hhl-compare__panel">' +
        '<header class="hhl-compare__head">' +
          '<div><h2 class="hhl-compare__title heading h5" id="hhl-compare-title"></h2>' +
          '<p class="hhl-compare__sub text--subdued text--small"></p></div>' +
          '<button type="button" class="hhl-compare__close" aria-label="Close">' +
            '<svg focusable="false" width="12" height="12" viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="hhl-compare__scroll"><table class="hhl-compare__table"></table></div>' +
      '</div>';
    document.body.appendChild(dialog);
    dialog.querySelector('.hhl-compare__close').addEventListener('click', close);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); }); // the backdrop
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });      // Escape
  };

  var close = function () {
    if (!dialog || !dialog.open) return;
    dialog.classList.remove('is-open');
    var done = function () { dialog.close(); document.documentElement.classList.remove('hhl-compare-lock'); };
    if (HHL.mq.reducedMotion.matches) done();
    else setTimeout(done, 220);
  };

  var addButton = function (data) {
    if (!data.available) return el('span', 'hhl-compare__sold text--subdued text--small', 'Sold out');
    if (!data.variant) {
      var link = el('a', 'hhl-compare__add hhl-compare__add--link', 'Choose options');
      link.href = data.url;
      return link;
    }
    var button = el('button', 'hhl-compare__add', 'Add to cart');
    button.type = 'button';
    button.addEventListener('click', function () {
      button.disabled = true;
      var settings = (window.themeVariables && themeVariables.settings) || {};
      var body = new FormData();
      body.append('id', data.variant);
      body.append('quantity', '1');
      body.append('sections', 'mini-cart');
      // Added the way the product tiles' quick add does it (Focal's product form, custom.js "quick-variants"), with
      // the same events after it, so the cart, its count, the drawer's "added" message and the analytics all follow
      fetch(HHL.cartUrl() + '/add.js', {
        method: 'POST',
        body: body,
        headers: { 'X-Requested-With': 'XMLHttpRequest' } // so Shopify answers a refused add with 422 and the reason
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (json) { return { ok: r.ok, json: json }; });
      }).then(function (result) {
        var json = result.json;
        if (!result.ok) {
          // Refused: Shopify's reason (no more in stock, for one) goes under the button; with none, "Try again"
          HHL.refreshCart();
          button.disabled = false;
          if (json.description) {
            button.textContent = 'Add to cart';
            note(button, json.description);
          } else {
            button.textContent = 'Try again';
            note(button, '');
          }
          return;
        }
        if (settings.cartType === 'page' || settings.pageType === 'cart') {
          window.location.href = HHL.root() + 'cart';
          return;
        }
        note(button, '');
        button.textContent = 'Added';
        button.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: json.hasOwnProperty('items') ? json.items[0] : json } }));
        HHL.fetchCart().then(function (cart) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          cart.sections = json.sections;
          HHL.refreshCart({ cart: cart, openMiniCart: settings.cartType === 'drawer' });
        });
        button.dispatchEvent(new CustomEvent('cart-notification:show', { bubbles: true, cancelable: true, detail: { status: 'success', error: '' } }));
        setTimeout(function () { button.disabled = false; button.textContent = 'Add to cart'; }, 1600);
      }).catch(function () {
        button.disabled = false;
        button.textContent = 'Try again';
      });
    });
    return button;
  };

  // Why an add was refused, in a line under its button. It opens its room and then fades in; cleared (text ''), it
  // goes the same way backwards and is removed. A new reason replaces the old one's words in place.
  var note = function (button, text) {
    var line = button.hhlNote;
    if (line && text) { line.textContent = text; return; }
    if (!text) {
      if (!line) return;
      button.hhlNote = null;
      fold(line, false, function () { line.remove(); });
      return;
    }
    line = button.hhlNote = el('span', 'hhl-compare__error', text);
    line.setAttribute('role', 'alert');
    button.insertAdjacentElement('afterend', line);
    fold(line, true);
  };

  var fold = function (line, opening, done) {
    if (HHL.mq.reducedMotion.matches || typeof line.animate !== 'function') {
      if (done) done();
      return;
    }
    var full = line.getBoundingClientRect().height;
    var gap = getComputedStyle(line).paddingTop;
    var run = line.animate([
      { height: '0px', paddingTop: '0px', opacity: 0, easing: HHL.ease },
      { height: full + 'px', paddingTop: gap, opacity: 0, offset: .55, easing: HHL.ease },
      { height: full + 'px', paddingTop: gap, opacity: 1 }
    ], { duration: 400 * HHL.motion() });
    if (!opening) run.reverse();
    if (done) run.onfinish = done;
  };

  var open = function (card) {
    if (!dialog) build();
    var features = [];
    try { features = JSON.parse(card.getAttribute('data-hhl-pairs-features') || '[]'); } catch (e) { features = []; }
    var handles = handlesOf(card);
    var title = card.getAttribute('data-hhl-pairs-title') || '';
    dialog.querySelector('.hhl-compare__title').textContent = 'Compare ' + title;
    // Store analytics (assets/custom.js, above hhlTrack): an add from here is "compare" in this group
    dialog.setAttribute('data-hhl-list', title);
    if (HHL.track) HHL.track('hhl_compare_opened', { list_name: title || null, part_count: handlesOf(card).length });
    dialog.querySelector('.hhl-compare__sub').textContent = 'All ' + handles.length + ' fit this product. Compare and pick the one for you.';

    var table = dialog.querySelector('.hhl-compare__table');
    table.innerHTML = '';
    dialog.style.setProperty('--hhl-compare-cols', String(handles.length)); // the dialog's width and the table's both read it
    var head = el('thead');
    var headRow = el('tr');
    headRow.appendChild(el('th', 'hhl-compare__corner'));
    var cells = handles.map(function () {
      var th = el('th', 'hhl-compare__product is-loading');
      th.setAttribute('scope', 'col');
      headRow.appendChild(th);
      return th;
    });
    head.appendChild(headRow);
    table.appendChild(head);
    var body = el('tbody');
    var rows = features.map(function (f) {
      var tr = el('tr');
      var th = el('th', 'hhl-compare__label', f.l);
      th.setAttribute('scope', 'row');
      tr.appendChild(th);
      var tds = handles.map(function () { var td = el('td', 'hhl-compare__value is-loading', '…'); tr.appendChild(td); return td; });
      body.appendChild(tr);
      return tds;
    });
    // "Good to know": each part's fit note with this product ("Trim the posts"), the one its tile has for the page's
    // selected version (snippets/hhl-tile-note.liquid; on the tile it may give way to the cart's line). Only when some
    // part has one.
    var pairs = card.closest('[data-hhl-pairs]');
    var notesOf = function (handle) {
      var slide = Array.prototype.filter.call(card.querySelectorAll('[data-hhl-pairs-slide]'), function (s) { return s.getAttribute('data-handle') === handle; })[0];
      var page = '|' + (pairs ? pairs.getAttribute('data-hhl-page-variant') || '' : '') + '|';
      var notes = slide ? Array.prototype.filter.call(slide.querySelectorAll('[data-hhl-fitnote]'), function (n) {
        var a = n.getAttribute('data-hhl-note-a');
        return !a || a.indexOf(page) !== -1;
      }) : [];
      return notes.slice(0, 1);
    };
    if (handles.some(function (h) { return notesOf(h).length; })) {
      var noteRow = el('tr');
      var noteHead = el('th', 'hhl-compare__label', 'Good to know');
      noteHead.setAttribute('scope', 'row');
      noteRow.appendChild(noteHead);
      handles.forEach(function (h) {
        var td = el('td', 'hhl-compare__value');
        var notes = notesOf(h);
        if (notes.length) notes.forEach(function (n) {
          var copy = n.cloneNode(true);
          copy.hidden = false;
          copy.classList.remove('is-new');
          // On the tile it is a badge on the photo; here the plain note
          copy.classList.remove('hhl-fitnote--chip', 'label');
          copy.removeAttribute('tabindex');
          var tag = copy.querySelector('.hhl-fitnote__tag');
          if (tag) tag.remove();
          td.appendChild(copy);
        });
        else td.textContent = '—';
        noteRow.appendChild(td);
      });
      body.insertBefore(noteRow, body.firstChild);
    }
    table.appendChild(body);

    var loaded = handles.map(function (handle, i) {
      return getSpec(handle).then(function (data) {
        if (!data) return;
        var th = cells[i];
        th.classList.remove('is-loading');
        var link = el('a', 'hhl-compare__link');
        link.href = data.url;
        var photo = el('span', 'hhl-compare__photo');
        if (data.image) {
          var img = el('img'); img.src = data.image; img.alt = ''; img.loading = 'lazy'; photo.appendChild(img);
          // The photo's focus and zoom from the Parts Catalog, when staff set one (custom.js "Photo crops")
          if (window.HHLCrop && data.crop) HHLCrop.apply(img, HHLCrop.find(data.crop, data.image));
        }
        var labels = el('span', 'hhl-compare__labels');
        (data.badges || []).forEach(function (b) {
          labels.appendChild(el('span', 'label label--' + (b.kind === 'custom2' ? 'custom2' : 'custom'), b.text));
        });
        photo.appendChild(labels);
        link.appendChild(photo);
        link.appendChild(el('span', 'hhl-compare__name', data.title));
        th.appendChild(link);
        th.appendChild(el('span', 'hhl-compare__price', (data.from ? 'From ' : '') + data.price));
        th.appendChild(addButton(data));
        features.forEach(function (f, r) {
          var td = rows[r][i];
          td.classList.remove('is-loading');
          td.textContent = show(f, data.specs ? data.specs[f.k] : null);
        });
        return data;
      }, function () {
        cells[i].classList.remove('is-loading');
        cells[i].textContent = 'Couldn’t load';
        return null;
      });
    });

    // "Popular": once every part is in, the one with clearly the most reviews
    Promise.all(loaded).then(function (all) {
      var best = -1, bestCount = 0, tie = false;
      all.forEach(function (data, i) {
        var count = data && data.reviews ? Number(data.reviews) : 0;
        if (count > bestCount) { best = i; bestCount = count; tie = false; } else if (count && count === bestCount) tie = true;
      });
      if (best < 0 || tie || bestCount < POPULAR_MIN) return;
      var labels = cells[best].querySelector('.hhl-compare__labels');
      if (labels) labels.insertBefore(el('span', 'label label--custom hhl-compare__popular', 'Popular'), labels.firstChild);
    });

    document.documentElement.classList.add('hhl-compare-lock');
    dialog.showModal();
    requestAnimationFrame(function () { dialog.classList.add('is-open'); });
  };

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-hhl-pairs-compare]');
    if (!button) return;
    var card = button.closest('[data-hhl-pairs-card]');
    if (card) open(card);
  });

  window.HHLCompare = { open: open, close: close };
})();
